WAU.DeliveryDate = {
  getMacauNow: function getMacauNow(config) {
    var tz = config.delivery_timezone || 'Asia/Macau';
    var formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: tz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    var parts = {};
    formatter.formatToParts(new Date()).forEach(function(part) {
      if (part.type !== 'literal') {
        parts[part.type] = part.value;
      }
    });
    return {
      year: parseInt(parts.year, 10),
      month: parseInt(parts.month, 10),
      day: parseInt(parts.day, 10),
      hour: parseInt(parts.hour, 10),
      minute: parseInt(parts.minute, 10)
    };
  },

  toISODate: function toISODate(dateParts) {
    return (
      dateParts.year +
      '-' +
      String(dateParts.month).padStart(2, '0') +
      '-' +
      String(dateParts.day).padStart(2, '0')
    );
  },

  parseISODate: function parseISODate(isoDate) {
    var pieces = isoDate.split('-');
    return {
      year: parseInt(pieces[0], 10),
      month: parseInt(pieces[1], 10),
      day: parseInt(pieces[2], 10)
    };
  },

  addDays: function addDays(dateParts, days) {
    var dt = new Date(Date.UTC(dateParts.year, dateParts.month - 1, dateParts.day));
    dt.setUTCDate(dt.getUTCDate() + days);
    return {
      year: dt.getUTCFullYear(),
      month: dt.getUTCMonth() + 1,
      day: dt.getUTCDate()
    };
  },

  getDayOfWeek: function getDayOfWeek(dateParts) {
    var dt = new Date(Date.UTC(dateParts.year, dateParts.month - 1, dateParts.day));
    return dt.getUTCDay();
  },

  isAfterCutoff: function isAfterCutoff(now, config) {
    var cutoffHour = config.delivery_cutoff_hour != null ? config.delivery_cutoff_hour : 16;
    var cutoffMinute = config.delivery_cutoff_minute != null ? config.delivery_cutoff_minute : 30;
    return now.hour > cutoffHour || (now.hour === cutoffHour && now.minute >= cutoffMinute);
  },

  skipSunday: function skipSunday(dateParts) {
    var current = dateParts;
    while (WAU.DeliveryDate.getDayOfWeek(current) === 0) {
      current = WAU.DeliveryDate.addDays(current, 1);
    }
    return current;
  },

  getEarliestDateParts: function getEarliestDateParts(config, now) {
    now = now || WAU.DeliveryDate.getMacauNow(config);
    var offset = WAU.DeliveryDate.isAfterCutoff(now, config) ? 2 : 1;
    var today = { year: now.year, month: now.month, day: now.day };
    return WAU.DeliveryDate.skipSunday(WAU.DeliveryDate.addDays(today, offset));
  },

  getEarliestDate: function getEarliestDate(config, now) {
    return WAU.DeliveryDate.toISODate(WAU.DeliveryDate.getEarliestDateParts(config, now));
  },

  getMaxDate: function getMaxDate(config, now) {
    now = now || WAU.DeliveryDate.getMacauNow(config);
    var horizon = config.delivery_horizon_days || 30;
    var today = { year: now.year, month: now.month, day: now.day };
    return WAU.DeliveryDate.toISODate(WAU.DeliveryDate.addDays(today, horizon));
  },

  getDateInputBounds: function getDateInputBounds(config, now) {
    return {
      min: WAU.DeliveryDate.getEarliestDate(config, now),
      max: WAU.DeliveryDate.getMaxDate(config, now)
    };
  },

  getAvailableDates: function getAvailableDates(config, now) {
    now = now || WAU.DeliveryDate.getMacauNow(config);
    var bounds = WAU.DeliveryDate.getDateInputBounds(config, now);
    var current = WAU.DeliveryDate.parseISODate(bounds.min);
    var max = bounds.max;
    var dates = [];

    while (WAU.DeliveryDate.toISODate(current) <= max) {
      if (WAU.DeliveryDate.getDayOfWeek(current) !== 0) {
        dates.push(WAU.DeliveryDate.toISODate(current));
      }
      current = WAU.DeliveryDate.addDays(current, 1);
    }

    return dates;
  },

  isValidDeliveryDate: function isValidDeliveryDate(isoDate, config, now) {
    if (!isoDate) {
      return false;
    }
    if (WAU.DeliveryDate.getDayOfWeek(WAU.DeliveryDate.parseISODate(isoDate)) === 0) {
      return false;
    }
    now = now || WAU.DeliveryDate.getMacauNow(config);
    var bounds = WAU.DeliveryDate.getDateInputBounds(config, now);
    return isoDate >= bounds.min && isoDate <= bounds.max;
  },

  formatDisplayDate: function formatDisplayDate(isoDate, locale) {
    if (!isoDate) {
      return '';
    }
    var parts = WAU.DeliveryDate.parseISODate(isoDate);
    var dt = new Date(parts.year, parts.month - 1, parts.day);
    return dt.toLocaleDateString(locale || document.documentElement.lang || 'en', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  },

  getAttributeKey: function getAttributeKey(config) {
    return config.delivery_date_attribute_key || 'delivery_date';
  },

  isEnabled: function isEnabled(config) {
    return !!config.delivery_scheduling_enabled;
  },

  getStoredDate: function getStoredDate(cart, config) {
    if (!cart || !cart.attributes) {
      return '';
    }
    return cart.attributes[WAU.DeliveryDate.getAttributeKey(config)] || '';
  },

  getSelectedDateFromDom: function getSelectedDateFromDom() {
    var input = document.querySelector('.js-cart-delivery-date');
    return input ? input.value : '';
  },

  isBlocked: function isBlocked(config, cart) {
    if (!WAU.DeliveryDate.isEnabled(config)) {
      return false;
    }
    if (!document.querySelector('.js-delivery-date-block')) {
      return false;
    }
    var selected =
      WAU.DeliveryDate.getSelectedDateFromDom() || WAU.DeliveryDate.getStoredDate(cart, config);
    return !WAU.DeliveryDate.isValidDeliveryDate(selected, config);
  },

  updateHelperText: function updateHelperText(config, now) {
    now = now || WAU.DeliveryDate.getMacauNow(config);
    var helperEls = document.querySelectorAll('.js-delivery-date-helper');
    if (!helperEls.length) {
      return;
    }

    var earliest = WAU.DeliveryDate.formatDisplayDate(
      WAU.DeliveryDate.getEarliestDate(config, now),
      document.documentElement.lang
    );
    var sundayNote = config.delivery_date_sundays_closed || '';
    var helperText;

    if (WAU.DeliveryDate.isAfterCutoff(now, config)) {
      helperText = (config.delivery_date_after_cutoff || '').replace('[[date]]', earliest);
    } else {
      helperText = config.delivery_date_before_cutoff || '';
    }

    helperEls.forEach(function(el) {
      el.textContent = helperText + (sundayNote ? ' ' + sundayNote : '');
    });
  },

  showError: function showError(message) {
    document.querySelectorAll('.js-delivery-date-error').forEach(function(el) {
      el.textContent = message || '';
      el.classList.toggle('hide', !message);
      el.hidden = !message;
    });
  },

  updateFilledState: function updateFilledState(config, now) {
    var selected = WAU.DeliveryDate.getSelectedDateFromDom();
    var filled = WAU.DeliveryDate.isValidDeliveryDate(selected, config, now);
    document.querySelectorAll('.js-delivery-date-block').forEach(function(block) {
      block.classList.toggle('is-filled', filled);
    });
  },

  populateSelect: function populateSelect(select, config, now, selectedValue) {
    var locale = document.documentElement.lang || 'en';
    var placeholder =
      config.delivery_date_placeholder || 'Select a delivery date';
    var dates = WAU.DeliveryDate.getAvailableDates(config, now);
    var html = '<option value="">' + placeholder + '</option>';

    dates.forEach(function(isoDate) {
      var selected = isoDate === selectedValue ? ' selected' : '';
      html +=
        '<option value="' +
        isoDate +
        '"' +
        selected +
        '>' +
        WAU.DeliveryDate.formatDisplayDate(isoDate, locale) +
        '</option>';
    });

    select.innerHTML = html;

    if (selectedValue && WAU.DeliveryDate.isValidDeliveryDate(selectedValue, config, now)) {
      select.value = selectedValue;
      if (select.value !== selectedValue) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === selectedValue) {
            select.selectedIndex = i;
            break;
          }
        }
      }
    } else {
      select.selectedIndex = 0;
    }

    // Force Safari/WebKit to repaint the closed-select label.
    select.style.color = '#122b1c';
    select.style.webkitTextFillColor = '#122b1c';
    WAU.DeliveryDate.updateFilledState(config, now);
  },

  applyInputBounds: function applyInputBounds(config, now, preferredValue) {
    now = now || WAU.DeliveryDate.getMacauNow(config);
    document.querySelectorAll('.js-cart-delivery-date').forEach(function(input) {
      var selected =
        preferredValue ||
        input.value ||
        input.getAttribute('data-selected-date') ||
        '';
      WAU.DeliveryDate.populateSelect(input, config, now, selected);
    });
  },

  persistDate: function persistDate(isoDate, config) {
    var key = WAU.DeliveryDate.getAttributeKey(config);
    var attrs = {};
    attrs[key] = isoDate;
    return WAU.ThemeCart.updateAttributes(attrs);
  },

  clearDate: function clearDate(config) {
    var key = WAU.DeliveryDate.getAttributeKey(config);
    var attrs = {};
    attrs[key] = '';
    return WAU.ThemeCart.updateAttributes(attrs);
  },

  syncFromCart: function syncFromCart(config, cart) {
    if (!WAU.DeliveryDate.isEnabled(config)) {
      return Promise.resolve(cart);
    }

    var now = WAU.DeliveryDate.getMacauNow(config);
    var stored = WAU.DeliveryDate.getStoredDate(cart, config);
    WAU.DeliveryDate.applyInputBounds(config, now, stored);
    WAU.DeliveryDate.updateHelperText(config, now);
    WAU.DeliveryDate.updateFilledState(config, now);

    if (stored && WAU.DeliveryDate.isValidDeliveryDate(stored, config, now)) {
      WAU.DeliveryDate.showError('');
      return Promise.resolve(cart);
    }

    if (stored) {
      return WAU.DeliveryDate.clearDate(config).then(function(state) {
        WAU.DeliveryDate.applyInputBounds(config, now, '');
        WAU.DeliveryDate.showError(config.delivery_date_invalid || '');
        return state;
      });
    }

    if (cart && cart.item_count > 0) {
      var earliest = WAU.DeliveryDate.getEarliestDate(config, now);
      return WAU.DeliveryDate.persistDate(earliest, config).then(function(state) {
        WAU.DeliveryDate.applyInputBounds(config, now, earliest);
        WAU.DeliveryDate.showError('');
        return state;
      });
    }

    return Promise.resolve(cart);
  },

  handleChange: function handleChange(input, config) {
    var now = WAU.DeliveryDate.getMacauNow(config);
    var value = input.value;

    input.setAttribute('data-selected-date', value || '');

    if (!value) {
      WAU.DeliveryDate.updateFilledState(config, now);
      WAU.DeliveryDate.showError(config.delivery_date_required || '');
      return WAU.DeliveryDate.clearDate(config).then(function(state) {
        WAU.AjaxCart.applyCheckoutGateState(config, state);
        return state;
      });
    }

    if (!WAU.DeliveryDate.isValidDeliveryDate(value, config, now)) {
      input.value = '';
      input.setAttribute('data-selected-date', '');
      WAU.DeliveryDate.updateFilledState(config, now);
      WAU.DeliveryDate.showError(config.delivery_date_invalid || '');
      return WAU.DeliveryDate.clearDate(config).then(function(state) {
        WAU.AjaxCart.applyCheckoutGateState(config, state);
        return state;
      });
    }

    WAU.DeliveryDate.updateFilledState(config, now);
    WAU.DeliveryDate.showError('');
    return WAU.DeliveryDate.persistDate(value, config).then(function(state) {
      WAU.AjaxCart.applyCheckoutGateState(config, state);
      return state;
    });
  },

  bindEvents: function bindEvents(config) {
    document.querySelectorAll('.js-cart-delivery-date').forEach(function(input) {
      if (input.dataset.deliveryDateBound === '1') {
        return;
      }
      input.dataset.deliveryDateBound = '1';
      input.addEventListener('change', function() {
        WAU.DeliveryDate.handleChange(input, config);
      });
    });

    document.querySelectorAll('.js-cart-form').forEach(function(form) {
      if (form.dataset.deliveryDateSubmitBound === '1') {
        return;
      }
      form.dataset.deliveryDateSubmitBound = '1';
      form.addEventListener('submit', function(event) {
        if (!WAU.DeliveryDate.isEnabled(config)) {
          return;
        }
        var selected = WAU.DeliveryDate.getSelectedDateFromDom();
        if (!WAU.DeliveryDate.isValidDeliveryDate(selected, config)) {
          event.preventDefault();
          WAU.DeliveryDate.showError(
            selected ? config.delivery_date_invalid : config.delivery_date_required
          );
        }
      });
    });
  },

  init: function init(config, cart) {
    if (!WAU.DeliveryDate.isEnabled(config)) {
      return Promise.resolve(cart);
    }

    WAU.DeliveryDate.bindEvents(config);
    return WAU.DeliveryDate.syncFromCart(config, cart).then(function(nextCart) {
      WAU.DeliveryDate.bindEvents(config);
      return nextCart;
    });
  }
};
